/**
 * Niskopriorytetowe zadanie (idle) z bezpiecznym fallbackiem dla Safari.
 * @param {IdleRequestCallback | () => void} callback
 * @param {{ timeout?: number }} [options]
 * @returns {{ cancel: () => void }}
 */
export function scheduleIdleTask(callback, options = {}) {
  const timeout = options.timeout ?? 12000;
  if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
    const id = window.requestIdleCallback(callback, { timeout });
    return {
      cancel: () => {
        try {
          window.cancelIdleCallback(id);
        } catch (_) {
          /* ignore */
        }
      },
    };
  }
  if (typeof window === 'undefined') {
    return { cancel: () => {} };
  }
  const delay = Math.min(Math.max(timeout / 4, 400), 4000);
  const tid = window.setTimeout(() => {
    callback({ didTimeout: true, timeRemaining: () => 0 });
  }, delay);
  return { cancel: () => window.clearTimeout(tid) };
}
